import {
  Col,
  ENotificationType,
  Row,
  TRtkErrorType,
  useShowToastNotification,
  useTranslation,
} from '@packages/utils';
import EditableTextArea from 'components/Base/EditableFields/EditableTextArea';
import { InplaceEditLabels } from 'components/Base/EditableFields/components/InplaceEditLabel';
import { EIconNames } from 'components/Base/Icon';
import { useUpdatePeopleOrganizationTitleMutation } from 'redux/apiSlice/people.slice';
import { TPeopleOrganizationTitleProps } from './PeopleOrganizationTitle.types';

const PeopleOrganizationTitle = ({
  organizationId,
  data,
  userId,
}: TPeopleOrganizationTitleProps) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.people.details.details-tab.organizations.title',
  });
  const { showToastNotification } = useShowToastNotification();
  const [updatePeopleOrganizationTitle, { isLoading, isError }] =
    useUpdatePeopleOrganizationTitleMutation();

  const onEdit = async (value: string) => {
    try {
      await updatePeopleOrganizationTitle({
        organizationId,
        title: value,
        userId,
      }).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
    } catch (e) {
      showToastNotification({
        message: (e as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Row align="middle" wrap={false} className="w-100">
      <Col>
        <InplaceEditLabels
          label={t('INPLACE_EDIT_LABEL')}
          icon={EIconNames.BADGE}
        />
      </Col>
      <Col flex="auto">
        <EditableTextArea
          onEdit={onEdit}
          title={data.title.value}
          isError={isError}
          isLoading={isLoading}
          autoSize={{ maxRows: 1 }}
          maxLength={250}
          showCount
          readonly={data?.title.allowedOperations.readonly}
          canRemove={data?.title.allowedOperations.canRemove}
          emptyText={t('EMPTY_TEXT')}
          placeholder={t('PLACEHOLDER')}
        />
      </Col>
    </Row>
  );
};

export default PeopleOrganizationTitle;
